import $http from "../axios";

const state = {
  inventoriesRefills: []
};

const getters = {
  inventoriesRefills: state => {
    return state.inventoriesRefills;
  },
  inventoriesRefillsReverse: state => {
    return state.inventoriesRefills.reverse();
  }
};

const actions = {
  getInventoriesRefills({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `inventories-refills?storeId=${data.storeId}&beginDate=${
            data.dates[0]
          }&endDate=${data.dates[1]}`
        )
        .then(res => {
          if (res.data.result === "ok") {
            commit(
              "SET_INVENTORIES_REFILLS",
              res.data.payload.inventoriesRefills
            );
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_INVENTORIES_REFILLS(state, inventoriesRefills) {
    state.inventoriesRefills = inventoriesRefills;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
